import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router";
import constants from '../../../constants/constants';
import { Card, Col, Modal, Row, Spin, Form, Input, Space, Button, Select, message, Radio, Divider, Tooltip } from 'antd';
import { CloseCircleOutlined, CopyOutlined, ExceptionOutlined, NotificationOutlined, SolutionOutlined, UserAddOutlined, ClockCircleOutlined, PhoneOutlined, SafetyOutlined, UserOutlined } from '@ant-design/icons';
import { DOB } from '../../../globalFunctions/GlobalFunctions';
import PhoneInput from 'react-phone-input-2';
import { fetchAdminApi, fetchApi } from '../../../services/api';
import TextArea from 'antd/es/input/TextArea';
import { COOKIE, getCookie } from '../../../services/cookie';

const { Option } = Select;

const RoycaresDashboard = () => {
	const [form] = Form.useForm();
	const [immersionForm] = Form.useForm();
	const [loginType] = useState(getCookie(COOKIE.LoginType));

	const history = useHistory();
	const cardDetails = [
		{
			key: 4,
			label: "Quick Client",
			icon: <UserOutlined />,
		},
		{
			key: 0,
			label: `Cold Caller/ ${constants.PotentialRecipient}`,
			icon: <PhoneOutlined />,
		},
		{
			key: 1,
			label: "Enquiries (Pre - Assessment)",
			icon: <ExceptionOutlined />
		},
		{
			key: 2,
			label: "Active Clients",
			icon: <SolutionOutlined />
		},
		{
			key: 13,
			label: "Continuing Care",
			icon: <SafetyOutlined />
		},
		{
			key: 9,
			label: "Pending Clients",
			icon: <ClockCircleOutlined />
		},
		{
			key: 7,
			label: 'Group Sessions',
			icon: <NotificationOutlined />
		},
		{
			key: 10,
			label: "Closed",
			icon: <CloseCircleOutlined />
		},
	];
	const layout = {
		labelCol: { span: 8 },
		wrapperCol: { span: 16 },
	};
	const verticalLayout = {
		labelCol: { span: 24 },
		wrapperCol: { span: 24 }
	};
	const tailLayout = { wrapperCol: { span: 24 } };
	const [openPotentialForm, setOpenPotentialForm] = useState(false);
	const [openImmersionForm, setOpenImmersionForm] = useState(false);
	const [loader, setLoader] = useState(false);
	const [emailValidateStatus, setEmailValidateStatus] = useState("");
	const [emailIdValue, setEmailIdValue] = useState(null);
	const [styles, setStyles] = useState(null);
	const [showOtherReasonForCall, setShowOtherReasonForCall] = useState(false);
	const [listCountries, setCountries] = useState([]);
	const [tempState, setTempState] = useState([]);
	const [countryPhoneCode, setcountryPhoneCode] = useState("");
	const [listStates, setListStates] = useState([]);
	const [workbookType, setWorkbookType] = useState(null);
	const [filteredOptions, setFilteredOptions] = useState(constants.AgreementOptions);
	const [listAssociates, setListAssociates] = useState([]);
	const [sharedWithList, setSharedWithList] = useState([]);
	const [userMessage, setUserMessage] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [username, setUsername] = useState(null);
	const [password, setPassword] = useState(null);

	const current = new Date();
	const [date, setDate] = useState({
		date: current.getDate(),
		month: String(current.getMonth() + 1).padStart(2, '0'),
		year: current.getFullYear()
	});
	const [followUpAssociateList, setFollowUpAssociateList] = useState([]);
	//date of notes date onchange
	const handleDayChange = (value) => {
		setDate({
			...date,
			date: value
		});
		form.setFieldsValue({ date: date });
	};
	const handleMonthChange = (value) => {
		setDate({
			...date,
			month: value
		});
		form.setFieldsValue({ date: date });
	};
	const handleYearChange = (value) => {
		setDate({
			...date,
			year: value
		});
		form.setFieldsValue({ date: date });
	};
	useEffect(() => {
		fetchCountries();
		getAssociateList();
		getAssociateFollowList();
	}, []);

	const getAssociateFollowList = () => {
		setLoader(true);

		const payload = { follow_up: 1 };

		fetchAdminApi(`/view-associates`, "post", payload)
			.then((res) => {
				if (res?.code === 200 && Array.isArray(res?.data)) {

					// Filtering
					const filtered = res.data.filter(item => item.client_id === "1");

					setFollowUpAssociateList(filtered);

					// Auto select first/only option
					if (filtered.length > 0) {
						form.setFieldsValue({
							follow_up: filtered[0].client_id
						});
					}
				} else {
					setFollowUpAssociateList([]);
				}
			})
			.catch(() => {
				setFollowUpAssociateList([]);
			})
			.finally(() => {
				setLoader(false);
			});
	};

	const handleValidateName = (rule, value, callback) => {
		try {
			if (value) {
				// eslint-disable-next-line no-useless-escape
				let nameValidate = /[`~@#$%^&*,<>;?:"\/\[\]\|{}()=+]/;
				if (nameValidate.test(value) === true) {
					throw new Error(constants.FirstNameInvalid);
				}
			}
			callback(); // < -- this
		} catch (err) {
			callback(err);
		}
	};
	const handleCheckEmail = () => {
		if (!emailIdValue) {
			setEmailValidateStatus(""); // Clear any validation
			return;
		}
		const payload = { email: emailIdValue };
		fetchApi("/client/register/check-emails", "post", payload).then((res) => {
			if (res?.code === 200) {
				setEmailValidateStatus("success");
			} else {
				setEmailValidateStatus("error");
			}
		});
	};
	const handleValidatePhone = (rule, value, callback) => {
		try {
			if (value) {
				let phoneValidate = /^(?=.{5,})\S*$/;
				if (phoneValidate.test(value) === false) {
					const stylesValidation = { border: '1px solid rgba(255, 77, 79)', };
					setStyles(stylesValidation);
					throw new Error(constants.PhoneNoRegistration);
				} else {
					setStyles(null);
				}
			}
			callback(); // < -- this
		} catch (err) {
			callback(err);
		}
	};
	const handleContactNo = (value) => {
		if (value === "" || value === null || value === undefined) {
			const stylesValidation = { border: '1px solid rgba(255, 77, 79)', };
			setStyles(stylesValidation);
		} else {
			setStyles(null);
		}
	};
	const handleReasonForCall = (val) => {
		setShowOtherReasonForCall(val === "9");
	};

	const handleImmersionFormToggle = () => {
		setOpenImmersionForm(true);
	};
	const handleImmersionCancel = () => {
		setOpenImmersionForm(false);
	};

	const onChangeWbType = (value) => {
		setWorkbookType(value);
		// Reset the agreement_duration field
		immersionForm.setFieldsValue({ agreement_duration: null });
	};

	useEffect(() => {
		if (workbookType === null) {
			setFilteredOptions(constants.AgreementOptions);
		} else if (workbookType === 0) {
			setFilteredOptions(constants.NonAddictAgreementOptions);
		} else {
			setFilteredOptions(constants.AddictAgreementOptions);
		}
	}, [workbookType]);

	const getAssociateList = () => {
		let payload = null
		fetchAdminApi(`/view-associates`, "post", payload).then((res) => {
			if (res?.data) {
				const associates = res?.data;
				const firstItem = associates.find(obj => obj?.client_id === "1");
				const remainingItems = associates.filter(obj => obj?.client_id !== "1");
				const sortedData = firstItem ? [firstItem, ...remainingItems] : remainingItems;

				// Select the first associate (or null if none)
				const selected = sortedData.length > 0 ? sortedData[0] : null;

				// Set sharedWithList by excluding selected
				const sharedList = sortedData.filter(obj => obj.client_id !== selected?.client_id);
				setSharedWithList(sharedList);

				setListAssociates(sortedData);
			} else {
				setListAssociates([]);
				setSharedWithList([]);
			}
		});
	};

	const handleAssociateChange = (value) => {
		if (!value) {
			setSharedWithList(listAssociates); // Reset shared list to all
			return;
		}

		// Update shared list excluding selected
		const shared = listAssociates.filter(item => item.client_id !== value);
		setSharedWithList(shared);
	};

	// City, state, country
	const fetchCountries = () => {
		fetchApi(`/countries`, "get").then((res) => {
			if (res && res.data && res.data.length > 0) {
				setCountries(res.data);
			} else {
				setCountries([]);
			}
		});
	};
	const onChangeCountry = (val, option) => {
		fetchStates(option?.key);
		setcountryPhoneCode(option?.key);

		form.setFieldsValue({ state: null });
	};
	const fetchStates = (country_code) => {
		fetchApi(`/states/${country_code}`, "get").then(
			(res) => {
				if (res?.data) {
					setTempState(res?.data);
					setListStates(res.data);
				} else {
					setListStates(null);
				}
			}
		);
	};

	const handleChangeCity = (rule, value, callback) => {
		try {
			//space not allowed initial and fullstop and hyphen is allowed.
			if (value && !/^[-.]?\S+(\s+\S+)*$/.test(value)) {
				throw new Error(constants.CityRegistration);
			}
			callback(); // < -- this
		} catch (err) {
			callback(err);
		}
	};

	const selectFilterOption = (input, option) =>
		(option?.label || '').toLowerCase().includes(input?.toLowerCase());


	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const ImmersionModal = (
		<Modal
			title={<div className="text-center">{constants.AddClient}</div>}
			open={openImmersionForm}
			footer={null}
			onOk={handleImmersionCancel}
			centered
			style={{ top: 20 }}
			width={800}
			className="client-details"
			onCancel={handleImmersionCancel}
		>
			<Spin spinning={loader} size="large">
				<Form
					labelWrap
					form={immersionForm}
					onFinish={(e) => onFinishImmersionForm(e)}
					{...verticalLayout}
				>
					<Row gutter={[24, 0]}>

						<Col xs={24} lg={12}>
							<Form.Item
								className="mb-3"
								name={"firstname"}
								label={constants.FirstName}
								rules={[
									{
										required: true,
										message: constants.FirstNameRegistration,
										whitespace: true
									},
									{ validator: handleValidateName },
								]}
							>
								<Input autoFocus placeholder={constants.FirstName} />
							</Form.Item>
						</Col>
						<Col xs={24} lg={12}>
							<Form.Item
								className="mb-3"
								name={"lastname"}
								label={constants.LastName}
								rules={[
									{ validator: handleValidateName },
								]}
							>
								<Input autoFocus placeholder={constants.LastName} />
							</Form.Item>
						</Col>
						<Col xs={24} lg={12}>
							<Form.Item
								name="email"
								label={constants.Email}
								validateStatus={emailValidateStatus}
								hasFeedback
								rules={[
									{
										type: 'email',
										message: constants.emailVaidationError,
									},
								]}
							>
								<Input
									placeholder={constants.EmailPlaceholder}
									onChange={(e) => {
										const value = e.target.value.toLowerCase();
										setEmailIdValue(value);

										// Clear validation status when input is empty
										if (!value) {
											setEmailValidateStatus("");
										}
									}}
									onBlur={() => {
										if (emailIdValue) {
											handleCheckEmail();
										}
									}}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} lg={12}>
							<Form.Item
								label={constants.phone}
								name="contact_no"
								rules={[
									{
										required: true,
										message: constants.PhoneNoRegistration,
									},
									{ validator: handleValidatePhone },
								]}
							>
								<PhoneInput preferredCountries={["us", "in"]} className='w-full' country={"in"} style={styles} onChange={handleContactNo} placeholder="1(999)123-4567" />
							</Form.Item>
						</Col>

						{/* Reason for contacting us */}
						<Col xs={24} lg={12}><Form.Item
							name="reason"
							label="Reason for contacting us?"
						>
							<Select
								placeholder="--Please choose an option--"
								allowClear
								className="w-full"
								onChange={handleReasonForCall}
							>
								{constants.ReasonForCallOptions.map((val) => (
									<Option key={val.value} value={val.value}>
										{val.label}
									</Option>
								))}
							</Select>
						</Form.Item></Col>
						{showOtherReasonForCall ? (<Col xs={24} lg={12}>
							<Form.Item
								name={"other_reason"}
								label={constants.OtherDetails}
							>
								<Input type="text" />
							</Form.Item> </Col>
						) : null}

						<Col xs={24}>
							<Form.Item >
								<Space className="float-right">
									<Button
										size="middle"
										onClick={() => handleImmersionCancel()}
									>
										{constants.CancelBTN}
									</Button>
									<Button
										size="middle"
										className='bg-sky-800 text-white uppercase'
										htmlType="submit"
									>
										{constants.Save}
									</Button>
								</Space>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Spin>
		</Modal>
	)

	const UserCreatedPopup = (
		<Modal
			title={
				<div>
					<UserAddOutlined className="text-5xl text-sky-900" />
				</div>
			}
			open={isModalOpen}
			onCancel={handleCancel}
			footer={null}
			className="welcome-modal text-center"
			width={410}
		>
			<div className="text-2xl font-bold mb-2.5 text-sky-900">
				Client was added successfully.
			</div>
			<div className="text-lg font-semibold text-slate-500" type="secondary">
				{username && password ? (
					<>
						<p>
							<strong>Username:</strong> {username}{' '}
							<Tooltip title="Copy Username">
								<Button
									type="link"
									size='large'
									icon={<CopyOutlined className="!text-lg text-sky-800 hover:text-sky-900" />}
									onClick={() => copyToClipboard(username)}
								/>
							</Tooltip>
						</p>
						<p>
							<strong>Password:</strong> {password}{' '}
							<Tooltip title="Copy Password">
								<Button
									type="link"
									size='large'
									icon={<CopyOutlined className="!text-lg text-sky-800 hover:text-sky-900" />}
									onClick={() => copyToClipboard(password)}
								/>
							</Tooltip>
						</p>
					</>
				) : (
					<p>{userMessage}</p>
				)}
			</div>
		</Modal>
	)

	const onFinishImmersionForm = (value) => {
		setLoader(true);
		// Add program_id based on client_type
		const programId = value.client_type === 1 ? 13 : 10;

		const payload = {
			...value,
			program_id: programId,
			is_immersion: 1, // Indicates direct client.
		};

		fetchAdminApi("/make-client", "post", payload).then((res) => {
			if (res?.code === 200) {
				setLoader(false);
				immersionForm.resetFields();
				message.success(res?.message);
				setUserMessage(res?.data);
				const msg = res?.data;
				const match = msg?.match(/username:\s*(\w+).*password\s*:\s*(\w+)/i);
				if (match) {
					setUsername(match[1]);
					setPassword(match[2]);
				}

				setIsModalOpen(true);
				handleImmersionCancel();
			} else {
				setLoader(false);
				message.error(res?.message);
				setUserMessage(null);
				setOpenImmersionForm(true);
			}
		});
	};

	const copyToClipboard = (text) => {
		if (!navigator.clipboard) {
			// fallback if clipboard API not supported
			const textArea = document.createElement("textarea");
			textArea.value = text;
			textArea.style.position = "fixed";  // avoid scrolling to bottom
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			try {
				document.execCommand('copy');
				message.success('Copied to clipboard!');
			} catch (err) {
				message.error('Failed to copy');
			}
			document.body.removeChild(textArea);
			return;
		}

		navigator.clipboard.writeText(text).then(() => {
			message.success('Copied to clipboard!');
		}, () => {
			message.error('Failed to copy');
		});
	};
	const handleOkCancel = () => {
		setOpenPotentialForm(!openPotentialForm);
	};
	const onClickCard = (type) => {
		switch (type) {
			case 0:
				history.push("/potential-recipient");
				break;
			case 1:
				history.push("/client-enquiry-open-list");
				break;
			case 2:
				history.push("/client-list-open");
				break;
			case 3:
				history.push("/client-list-closed");
				break;
			case 4:
				handleImmersionFormToggle();
				break;
			case 5:
				history.push("/client-enquiry-list-all");
				break;
			case 6:
				history.push("/client-enquiry-forceclosed-list");
				break;
			case 7:
				history.push("/group-sessions-dashboard");
				break;
			case 8:
				history.push("/associate-dashboard");
				break;
			case 9:
				history.push("/pending-clients");
				break;
			case 10:
				history.push("/client-enquiry-closed-list");
				break;
			default:
				break;
		}
	};
	return (
		<div>
			<div className='text-center bg-amber-300 text-lg font-semibold p-3'>{constants.Subtitle}</div>
			<div className='mx-6 mb-6 mt-6'>
				<div className="mb-4">
					<div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
						{cardDetails
							.map((val) => (
								<Card
									key={val?.key}
									styles={{ body: { height: "100%" } }}
									size="small"
									className="bg-amber-200 text-slate-800 text-center min-h-[140px] cursor-pointer hover:shadow-lg"
									onClick={() => onClickCard(val?.key)}
								>
									<div className="h-full grid place-content-center gap-3">
										<div className="text-center text-4xl sm:text-5xl ">{val.icon}</div>
										<span className="text-sm sm:text-base font-bold ">{val.label}</span>
									</div>
								</Card>
							))}
					</div>
				</div>
			</div>
			{ImmersionModal}
			{UserCreatedPopup}
		</div>
	)
}

export default RoycaresDashboard